export const INFO_ITEM_SERVICE_REQUESTS = {
  inactiveUnit: {
    subtitle: 'Help',
    title: 'Inactive Device',
    body: (
      <div>
        <p>An inactive device is a device which has not been programmed, and is not yet ready for use.</p>
        <br />
        <p>
          An inactive device needs to first go through the activation process to configure settings which enable it to communicate, making
          it ready for use.
        </p>
      </div>
    )
  },
  existingUnit: {
    subtitle: 'Help',
    title: 'Existing Device',
    body: (
      <div>
        <p>An existing device, already in use which is being replaced by a new device.</p>
        <br />
        <p>
          The new device will carry over all details and settings from this existing device, making it ready for use immediately after
          activation.
        </p>
      </div>
    )
  }
  // unitReplacement: {
  //   subtitle: 'Help',
  //   title: 'Activation Account',
  //   body: (
  //     <div>
  //       <p>
  //         <span className='jost'>New account</span>
  //         <br />
  //         Select a CID account number for the device. The device will be activated as a new connection, with a new CID account.
  //       </p>
  //       <br />
  //       <p>
  //         <span className='jost'>Existing account</span>
  //         <br />
  //         Select an existing device which will be replaced by the newly activated device. The newly activated device will carry over all
  //         details and settings from the old, and the old device will be cancelled upon completion of the device activation.
  //       </p>
  //     </div>
  //   )
  // }
}
